var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRad2Grey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.986,
    height: 12.986,
    viewBox: "0 0 12.986 12.986",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M-2869.508-9314.013h-1.276v-.894h.589a1.3,1.3,0,0,0,1.293-1.293v-.583h.894v1.271A1.5,1.5,0,0,1-2869.508-9314.013Zm-8.705,0h-1.283a1.5,1.5,0,0,1-1.5-1.5v-1.271h.894v.583a1.294,1.294,0,0,0,1.292,1.293h.6v.893Zm10.205-10.2h-.894v-.6a1.294,1.294,0,0,0-1.293-1.291h-.589V-9327h1.276a1.5,1.5,0,0,1,1.5,1.5v1.287Zm-12.092,0h-.894v-1.288a1.5,1.5,0,0,1,1.5-1.5h1.283v.895h-.6a1.293,1.293,0,0,0-1.292,1.291v.6Z",
    transform: "translate(2880.994 9326.999)",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRad2Grey);
export default __webpack_public_path__ + "static/media/rad2Grey.407c3033fd80a6eff52cd3802c0f778f.svg";
export { ForwardRef as ReactComponent };